<template>
  <box-model title="土壤墒情">
    <template v-slot:content>
      <div v-if="selList.length" class="select-part">
        <select-box :sty="false" :list="selList" :item="selItem" @sel="selEvent" keyword="id"></select-box>
      </div>
      <div class="con flex-between">
        <div class="left">
          <div class="l-title">
            <span>测量位置丨</span>
            <span style="font-size: 12px;font-weight: 400;color: #FFFFFF;">5CM土壤测量点</span>
          </div>
          <div class="lc-item">
            <img class="lc1-img" src="../../assets//img/trwd.png" />
            <div class="lc-info1">
              <div class="lc1-txt">土壤温度</div>
              <div class="lc1-num">{{ detail.temperature || '--' }}<span style="font-size: 16px;font-weight: 400;">℃</span></div>
            </div>
          </div>
          <div class="lc-item">
            <img class="lc2-img" src="../../assets//img/trsd.png" />
            <div class="lc-info2">
              <div class="lc2-txt">土壤湿度</div>
              <div class="lc2-num">{{ detail.humidity || '--' }}<span style="font-size: 16px;font-weight: 400;">%</span></div>
            </div>
          </div>
        </div>
        <div class="right">
          <div v-for="(item, index) in rList" :key="index" class="item flex-y-center">
            <div class="il"></div>
            <div class="rl"></div>
            <div class="rt">{{ item.name }}</div>
            <div class="num">{{ item.num }}</div>
            <div class="unit">{{ item.unit }}</div>
          </div>
        </div>
      </div>
    </template>
  </box-model>
</template>
<script>
  import { getIotSoilsList, getByIdAndType } from "@/api/index";
  export default {
    data() {
      return {
        selList: [],
        selItem: {},

        detail: {},

        rList: []
      }
    },
    components: {
      "box-model": () => import("../../components/common/Model.vue"),
      "select-box": () => import("../../components/common/SelectBox.vue")
    },
    mounted(){
      this.getIotSoilsListEvent();
    },
    methods: {
      selEvent(item){
        this.selItem = item;
        this.getByIdAndTypeEvent(item.code);
      },
      getIotSoilsListEvent(){
        getIotSoilsList().then((res) => {
          this.selList = res.data.records || [];
          if(this.selList.length){
            this.selItem = this.selList[0];
            this.getByIdAndTypeEvent(this.selItem.code);
          }
        })
      },
      getByIdAndTypeEvent(code){
        getByIdAndType({
          devType: 'soils',
          code: code
        }).then((res) => {
          const result = res.data || {};
          this.detail = res.data;
          this.rList = [
            {name: '盐分', num: result.specific_conductance || 0, unit: 'mg/kg'},
            {name: '含氮量', num: result.nitrogen || 0, unit: 'mg/kg'},
            {name: '含磷量', num: result.phosphor || 0, unit: 'mg/kg'},
            {name: '含钾量', num: result.kalium || 0, unit: 'mg/kg'},
            {name: 'PH', num: result.ph_num || 0 }
          ]
        })
      }
    }
  }
</script>
<style scoped lang="less">
  .select-part {
    position: absolute;
    top: -10px;
    right: 20px;
    width: 100px;
    font-size: 14px;
    font-weight: 400;
  }
  .con {
    width: 100%;
    padding-top: 20px;
    .left {
      width: 200px;
      padding-top: 10px;
      .l-title {
        height: 14px;
        font-size: 14px;
        font-weight: 700;
        color: #4ADDFF;
        line-height: 14px;
      }
      .lc-item {
        position: relative;
        display: flex;
        width: 100%;
        height: 48px;
        margin-top: 32px;
        .lc1-img {
          position: absolute;
          top: 0;
          right: 12px;
          z-index: 0;
          width: 152px;
          height: 48px;
        }
        .lc2-img {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 0;
          width: 152px;
          height: 48px;
        }
        .lc-info1 {
          position: relative;
          z-index: 3;
          height: 100%;
          margin-left: auto;
          margin-right: 36px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          .lc1-txt {
            height: 14px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(255,255,255,0.702);
            line-height: 14px;
          }
          .lc1-num {
            font-size: 20px;
            font-weight: 700;
            color: #FFFFFF;
            line-height: 20px;
          }
        }
        .lc-info2 {
          position: relative;
          z-index: 3;
          height: 100%;
          margin-left: 24px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          .lc2-txt {
            height: 14px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(255,255,255,0.702);
            line-height: 14px;
          }
          .lc2-num {
            font-size: 20px;
            font-weight: 700;
            color: #FFFFFF;
            line-height: 20px;
          }
        }
      }
    }
    .right {
      width: 180px;
      .item {
        position: relative;
        width: 100%;
        height: 32px;
        background: rgba(9,148,255,0.14);
        margin-bottom: 10px;
        padding: 0 14px;
        .il {
          position: absolute;
          left: 0;
          top: 0;
          width: 4px;
          height: 100%;
          border: 1px solid #38EAFF;
          border-right: none;
        }
        .rl {
          position: absolute;
          right: 0;
          top: 0;
          width: 4px;
          height: 100%;
          border: 1px solid #38EAFF;
          border-left: none;
        }
        .rt {
          font-size: 15px;
          font-weight: 400;
          color: #FFFFFF;
        }
        .num {
          font-size: 18px;
          font-weight: 700;
          color: #4ADDFF;
          margin-left: auto;
        }
        .unit {
          width: 36px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(255,255,255,0.7);
          margin-left: 6px;
        }
      }
      .item:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>